import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { backFallback, canGoBackInApp } from "../../lib/backNavigation";

/**
 * iOS-style back chevron for the header of a detail screen. Goes back in
 * history (the listing keeps its filters, which live in the URL, and
 * ScrollToTop restores its scroll position); with no earlier screen in this
 * app it replaces the current one with a sensible parent instead.
 */
export default function BackButton({ className = "" }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const goBack = () => {
    if (canGoBackInApp(window.history.state)) navigate(-1);
    else navigate(backFallback(pathname), { replace: true });
  };
  return (
    <button
      type="button"
      onClick={goBack}
      aria-label="Back"
      data-testid="header-back-btn"
      className={`header-back-btn inline-flex items-center justify-center min-w-[44px] min-h-[44px] -ml-3 ${className}`}
    >
      <ChevronLeft size={28} strokeWidth={2} />
    </button>
  );
}
